import { mdiEmail, mdiTelegram } from "@mdi/js";

export const ACTION_ICON_MAP = {
    "send_emails": mdiEmail,
    "telegram": mdiTelegram
}